/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assign = assign;
exports.default = void 0;
function assign(target) {
  if (target === null || target === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  for (var _len = arguments.length, to = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    to[_key - 1] = arguments[_key];
  }
  to.forEach(function (toItem) {
    toItem = Object(toItem);
    Object.keys(toItem).forEach(function (key) {
      target[key] = toItem[key];
    });
  });
  return target;
}
var _default = typeof Object.assign === 'function' ? Object.assign : assign;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/assign.js
// module id = 25
// module chunks = 0